'use client'

import { HTMLAttributes } from 'react'
import { HistoryChart } from '@/shared/ui/history-chart-component/history-chart'
import { HistoryChartTab } from './history-chart-tab'
import { HistorySummary } from './history-summary'
import { HistoryChartHeader } from './history-chart-header'
import { AnimatePresence, motion } from 'framer-motion'
import { useProductDetailPriceHistories } from '@/shared/ui/history-chart-component/use-product-detail-price-histories'
type ProductDetailPriceHistoryProps = {}

export const ProductDetailPriceHistory = ({
  className,
  ...props
}: ProductDetailPriceHistoryProps & HTMLAttributes<HTMLDivElement>) => {
  const { isShow } = useProductDetailPriceHistories()
  return (
    <div className={className} {...props}>
      <HistoryChartHeader />
      <AnimatePresence>
        {isShow && (
          <motion.div
            className="mt-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
          >
            <HistoryChartTab />
            <HistoryChart height={260} />
            <HistorySummary />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
